import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import './AuthLayout.scss';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';

interface AuthLayoutProps {}

const AuthLayout: FC<AuthLayoutProps> = () => (
  <div className="AuthLayout">
    <Typography variant="h1">NABLA DEVELOPER DASHBOARD</Typography>

    <Paper>
      <Outlet />
    </Paper>
  </div>
);

export default AuthLayout;
